import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import TreeViewer from "./SolrTest/tree/TreeViewer.js";
import ResultViewer from "./SolrTest/results/ResultViewer.js";

export default class PageDefault extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageDefault - Hello world");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }

    this.createTree();
  }

  doSearch(terms, collection, field = null) {
    const rv = new ResultViewer();
    rv.search(terms, collection, field);
  }

  get isHomepage() {
    return true;
  }

  createTree() {
    const tree = new TreeViewer(jQuery(".js-table-tree"), jQuery(".js-tree-data-content"));
    tree.init();
  }
}
